import { ITimerCreateOptions } from './interfaces';
import { dateNow } from './utils';
import requestInterval from './utils/requestInterval';
import { Timer } from './Timer';
import { PRECISION } from './constants/constants';

type Primitive = number | string;

class TimersRegistry {
    private readonly timers = new Map<Primitive, Timer>();

    private idIndex = 0;

    constructor() {
        const shift = Date.now() - dateNow();

        requestInterval(
            () => {
                if (!this.timers.size) {
                    return;
                }

                const currentTime = dateNow();
                this.timers.forEach((timer) => {
                    timer.tick(currentTime);
                });
            },
            PRECISION,
            shift,
        );
    }

    public create({ id, seconds, offsetSeconds, ...subscribeOptions }: ITimerCreateOptions): {
        instance: Timer;
        destroy: () => void;
    } {
        if (!id) {
            this.idIndex--;
        }

        const timerId = id || this.idIndex;
        const timer = new Timer(seconds, offsetSeconds);

        this.timers.set(timerId, timer);

        timer.subscribe(subscribeOptions);

        return {
            instance: timer,
            destroy: () => {
                this.remove(timerId);
            },
        };
    }

    public get(id: Primitive): Timer {
        return this.timers.get(id);
    }

    public remove(id: Primitive): void {
        this.timers.delete(id);
    }
}

export default new TimersRegistry();
